import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

// mui
import Drawer from '@mui/material/Drawer';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import SendIcon from '@mui/icons-material/Send';
import LinearProgress from '@mui/material/LinearProgress';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// Our components
import RateDrawer from '../../../pages/General/RateDrawer'
import SenderAddressSelect from '../../../pages/General/NewOrder/SenderAddressSelect'
import RecipientAddressSelect from '../../../pages/General/NewOrder/RecipientAddressSelect'
import LineItems from '../../General/NewOrder/LineItems';
import MultiPackageDimensions from '../../../pages/General/NewOrder/MultiPackageDimensions';
import Notification from '../../../pages/General/Notification'
import Printer from '../../../pages/General/Printer'
import OrderNote from '../../../pages/General/OrderNote'

// slice
import { doGetRate, resetRateState } from '../../../pages/Shipments/NewShipment/rateSlice';
import { fetchAddressBilling } from '../../../pages/Settings/AddressBilling/addressBillingSlice';
import { fetchSenderAddress } from '../../../pages/Settings/AddressSender/addressSenderSlice';
import { fetchCountry, fetchState,fetchMultiStates } from '../../../pages/General/countryStateCitySlice';
import { fetchBoxData } from '../../../pages/Settings/Box/boxSlice';
import { dopostDataCreateShipment,resetOrderNoteNotifications } from '../../../pages/Orders/ordersSlice';
import { fetchProfile } from '../../Settings/Profile/profileSlice';
import WidthMaximize from '../WidthMaximize'
import { fetchSkuINfo,resetLineItemSettingsState } from '../../../pages/Settings/ProductLineItems/lineitemSettingsSlice';

const NewOrderCreateDrawer = ({ visible, reportName, newOrderFormData, isRateAutoEnabled, meta, onClose, isDuplicateOrder, isReturnOrder, setNewOrderFormData, setNewOrderCreateDrawerVisible = () => { }, choosenTrackingNumber = 0, isShipmentCreationFlow = false,isLabelPrint= true,isFailedShipment=false,setIsReturnOrder,currentOrderId="" }) => {
    const dispatch = useDispatch();
    // state
    const country_code = useSelector(state => state.countrystate.country);
    const orders = useSelector(state => state.orders.createShipment);
    const lineItemsWeight = useSelector(state => state.orders && state.orders.lineItemsWeight);
    const orderNotesData = useSelector(state => state.orders && state.orders.orderNote);
    const state = useSelector(state => state.countrystate.state);
    const box = useSelector(state => state.box);
    const addresssender = useSelector(state => state.addresssender);
    const addressbilling = useSelector(state => state.addressbilling);
    const profile = useSelector(state => state.profile);
    const rates = useSelector(state => state.rates);
    // const
    const [formDataValues, setFormDataValues] = useState("")
    const [senderAddressObjectId, setSenderAddressObjectId] = useState('');
    const [rateDrawervisible, setRateDrawervisible] = useState(false);
    const [lineItemId, setLineItemId] = useState([]);
    const [drawer, setDrawer] = useState(true);
    const [isLabelOpened, setIsLabelOpened] = useState(true)
    const [isRateShown, setIsRateShown] = useState(false)
    const [showFieldErrors, setShowFieldErrors] = useState(false)
    const [snackOpen, setsnackOpen] = useState(false)
    const [orderId, setOrderId] = useState("")
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [customLineItems, setCustomLineItems] = useState([])
    const [customboxDimensions, setcustomboxDimensions] = useState({})
    const [isFailedLabelPrinted, setIsFailedLabelPrinted] = useState(true)
    const [createButtonDisable,setCreateButtonDisable] = useState(false)
    const [skus, setSkus] = useState([])
    const [boxValues, setBoxValues] = useState([])
    const [boxDimensions, setboxDimensions] = useState([]);
    const [customInsuranceAmount, setCustomInsuranceAmount] = useState("100");
    const [lineItemActualWeightState, setLineItemActualWeightState] = useState(0);
    const [drawerWidth, setDrawerWidth] = useState("90%");
    const topRef = useRef(null);

    const initialDimValues = {
        "length": "",
        "width": "",
        "height": "",
        "dimension_unit": "",
        "actual_weight": "",
        "weight_unit": "",
        "use_actual_weight": false,
        "choosenmeasurement": 0,
        "insurance_amount": "100"
    }
    const [defaultBoxDim, setDefaultBoxDim] = useState(initialDimValues)
    const [multiPackageFields, setMultiPackageFields] = useState([])
    const [errors, setErrors] = useState({});
    const [dimensionsErrors, setDimensionsErrors] = useState({});
    const [docIdCreate, setdocIdCreate] = useState("");
    useEffect(() => {
        let data = [...multiPackageFields];
        data.splice(0, 1)
        data = [{ ...defaultBoxDim }]
        setMultiPackageFields(data)
    }, [defaultBoxDim])

    useEffect(() => {
        if (rates && rates.message && rates.message.length !== 0) {
            setsnackOpen(true)
        }
    }, [rates]);

    // const handleClose = () => {
    //     dispatch(resetRateState())
    //     setsnackOpen(false)
    // };

    const onMultiPackageAdd = () => {
        let defaultBoxDimCopy = { ...defaultBoxDim }
        setMultiPackageFields([...multiPackageFields, defaultBoxDimCopy])
    }

    const onMultiPackageRemove = (index) => {
        let data = [...multiPackageFields];
        data.splice(index, 1)
        setMultiPackageFields(data)
    }
 
    const handleMultiPackageDimensionInputChange = (dimDataIndex, event) => {
        let packageFieldData = [...multiPackageFields];
        if (event.target.name == "choosenmeasurement") {
            if (event.target.value != 0) {
                box && box.data && box.data.map((boxData) => {
                    let lineItemAcutualWeightFormat=0
                    if(newOrderFormData && newOrderFormData.line_items && newOrderFormData.line_items.length!==0){
                        newOrderFormData.line_items.map((item) => {
                            lineItemAcutualWeightFormat = (item && item.actual_weight && item.actual_weight!="") ? parseFloat(lineItemAcutualWeightFormat)+parseFloat(item.actual_weight) : parseFloat(lineItemAcutualWeightFormat);
                        })
                    }
                    if (boxData._id === event.target.value) {
                        if(newOrderFormData && newOrderFormData.line_items && newOrderFormData.line_items.length!==0 && typeof newOrderFormData.line_items[0].weight_unit !== "undefined"){
                            if(newOrderFormData.line_items[0].weight_unit===boxData.box_weight_unit){
                                lineItemAcutualWeightFormat=lineItemAcutualWeightFormat
                            }else{
                                let actualWeightUnit=newOrderFormData.line_items[0].weight_unit
                                lineItemAcutualWeightFormat=converToWeightUnit(lineItemAcutualWeightFormat, actualWeightUnit,boxData.box_weight_unit)
                            }
                        }
                        packageFieldData[dimDataIndex] = {
                            "length": parseFloat(boxData.box_length).toFixed(2),
                            "width": parseFloat(boxData.box_width).toFixed(2),
                            "height": parseFloat(boxData.box_height).toFixed(2),
                            "dimension_unit": boxData.box_length_unit,
                            "actual_weight": (lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.length>0 && customLineItems.length >0) ? getLineItemWeight(customLineItems) : (lineItemAcutualWeightFormat!==0 && boxData.use_actual_weight && boxData.use_actual_weight===true) ? parseFloat(lineItemAcutualWeightFormat).toFixed(2) :parseFloat(boxData.box_weight).toFixed(2),
                            "weight_unit": (lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.length>0 && customLineItems.length >0) ? getLineItemWeightUnit(customLineItems) : boxData.box_weight_unit,
                            "choosenmeasurement": event.target.value,
                            "insurance_amount": customInsuranceAmount
                        }
                    }
                })
            } else {
                packageFieldData[dimDataIndex] = {
                    "length": "",
                    "width": "",
                    "height": "",
                    "dimension_unit": "",
                    "actual_weight": "",
                    "weight_unit": "",
                    "choosenmeasurement": event.target.value,
                    "insurance_amount": customInsuranceAmount
                }
            }
        } else {
            // 1. Update the field the user actually changed
            packageFieldData[dimDataIndex][event.target.name] = event.target.value;

            // 2. AUTO-MAPPING LOGIC: Only trigger if the user changed 'weight_unit'
            if (event.target.name === "weight_unit") {
                if (event.target.value === "lb") {
                    packageFieldData[dimDataIndex]["dimension_unit"] = "in";
                } else if (event.target.value === "kg" || event.target.value === "g") {
                    packageFieldData[dimDataIndex]["dimension_unit"] = "cm";
                }
            }
        }
        setMultiPackageFields(packageFieldData);
    }

    const rateDraweronClose = (values) => {
        setRateDrawervisible(false);
    };
    
    const initialFValues = {
        name: '', company: '', phone: '', email: '', address: '', address2: '', city: '', postal_code: '', country_code: '',
        weight: '', box_weight: '', actual_weight: '', province_code: '', preferred_sender_id: '', sender_name: '', sender_company: '',
        sender_phone: '', sender_email: '', sender_address: '', sender_address2: '', sender_city: '', sender_province_code: '',
        sender_postal_code: '', sender_country_code: '', length: '', height: '', width: '', dimension_unit: 'in', weight_unit: 'lb',
        insurance_amount: "", choosemeasurement: '', preferred_carrier: '', preferred_carrier_reference_id: '', preferred_service: '',
        sender_reference_no: '', return_shipment_sender_id: "", shipment_type: "PACKAGE", vat_no: "", delivery_notes: "",
        is_signature_required: (profile && profile.profile && typeof profile.profile.is_signature_required !== "undefined") ? profile.profile.is_signature_required : false,
        is_deliver_to_po_address: (profile && profile.profile && typeof profile.profile.is_deliver_to_po_address !== "undefined") ? profile.profile.is_deliver_to_po_address : false,
        is_leave_at_door_shipment: (profile && profile.profile && typeof profile.profile.is_leave_at_door_shipment !== "undefined") ? profile.profile.is_leave_at_door_shipment : false,
    }
    const [values, setValues] = useState(newOrderFormData !== '' ? newOrderFormData : initialFValues);

    const validate = (fieldValues = values) => {
        let temp = { ...errors }
        let dimensionsErrorsTemp = {}
        if ('name' in fieldValues) temp.name = (fieldValues.name.trim() == "") ? "This field is required." : ""
        if ('address' in fieldValues) temp.address = (fieldValues.address.trim() == "") ? "This field is required." : ""
        if ('city' in fieldValues) temp.city = (fieldValues.city.trim() == "") ? "This field is required." : ""
        if ('postal_code' in fieldValues) temp.postal_code = (fieldValues.postal_code.trim() == "") ? "This field is required." : ""
        if (fieldValues && fieldValues.postal_code && fieldValues.postal_code.match(/[^0-9a-z-\s]/i)) temp.postal_code = "Postal code only accepts alpha numeric"
        
        if ('country_code' in fieldValues) {
            if (fieldValues.country_code.trim() == "") {
                temp.country_code = "This field is required."
            } else {
                temp.country_code = ""
                if (fieldValues.country_code.trim().toUpperCase() == "US" || fieldValues.country_code.trim().toUpperCase() == "CA") {
                    if ('province_code' in fieldValues) temp.province_code = (fieldValues.province_code.trim() == "") ? "This field is required." : ""
                }
            }
        }
        
        if ('sender_name' in fieldValues) temp.sender_name = (fieldValues.sender_name.trim() == "") ? "This field is required." : ""
        if ('sender_address' in fieldValues) temp.sender_address = (fieldValues.sender_address.trim() == "") ? "This field is required." : ""
        if ('sender_city' in fieldValues) temp.sender_city = (fieldValues.sender_city.trim() == "") ? "This field is required." : ""
        if ('sender_postal_code' in fieldValues) temp.sender_postal_code = (fieldValues.sender_postal_code.trim() == "") ? "This field is required." : ""
        if ('sender_country_code' in fieldValues) temp.sender_country_code = (fieldValues.sender_country_code.trim() == "") ? "This field is required." : ""
        if ('sender_province_code' in fieldValues) temp.sender_province_code = (fieldValues.sender_province_code.trim() == "") ? "This field is required." : ""

        if (multiPackageFields && multiPackageFields.length != 0) {
            let dimError = false
            multiPackageFields.forEach((dim_data, dim_index) => {
                dimensionsErrorsTemp[dim_index] = { "length": "", "width": "", "height": "", "dimension_unit": "", "actual_weight": "", "weight_unit": "", "insurance_amount": "" }
                if (dim_data["length"] == "" || dim_data["length"] <= 0) { dimensionsErrorsTemp[dim_index]["length"] = "length is required"; dimError = true; }
                if (dim_data["width"] == "" || dim_data["width"] <= 0) { dimensionsErrorsTemp[dim_index]["width"] = "width is required"; dimError = true; }
                if (dim_data["height"] == "" || dim_data["height"] <= 0) { dimensionsErrorsTemp[dim_index]["height"] = "height is required"; dimError = true; }
                if (dim_data["actual_weight"] == "" || dim_data["actual_weight"] <= 0) { dimensionsErrorsTemp[dim_index]["actual_weight"] = "actual weight is required"; dimError = true; }
            })
            setDimensionsErrors(dimensionsErrorsTemp)
            if (dimError == true) return false
        }
        setErrors({ ...temp })
        if (fieldValues === values) return Object.values(temp).every(x => x === "")
    }

    const dispatchInputChangeCallback = (name, value) => {
        var newvalue={};
        var intialValue=value.trim();
        var addressValue=intialValue.split(/\r?\n/)
        if(addressValue.length>1){
        newvalue["name"]= addressValue[0];
     
        if(addressValue[1].length>35){
            var index = 0,
            res = [];
            while ((index = addressValue[1].indexOf(' ', index + 1)) > 0) {
            res.push(index);
            }
            var a=""
            for (var i = res.length; i > 0; i--) {
                if(res[i]<35){
                    a= res[i]
                    break
                }
            }
        const result = [addressValue[1].slice(0, a), addressValue[1].slice(a)];
        newvalue["address"]= result[0];
        newvalue["address2"]= result[1];
        }else{
            newvalue["address"]= addressValue[1];
        }
        if(addressValue.length>2){
            let multiLinePostal=addressValue[2];
            if(multiLinePostal.includes(',')){
                let multiLinePostalSplit=multiLinePostal.split(',');
                newvalue["city"]= multiLinePostalSplit[0];
                if(multiLinePostal.includes(' ')){
                    let multiLineStateCountrySplit=multiLinePostalSplit[1].split(' ');
                    let multiLineStateCountrySplitFilter=multiLineStateCountrySplit.filter(n => n)
                    newvalue["province_code"]= multiLineStateCountrySplitFilter[0];
                    if(multiLineStateCountrySplitFilter.length>=2){
                        var newvalue_postal_code=multiLineStateCountrySplitFilter[1];
                        if(multiLineStateCountrySplitFilter.length>2){
                            newvalue_postal_code= newvalue_postal_code + multiLineStateCountrySplitFilter[2];
                        }
                        newvalue["postal_code"]= newvalue_postal_code;
                        if(multiLineStateCountrySplitFilter.length>3){
                            newvalue["country_code"]= multiLineStateCountrySplitFilter[3];
                            dispatch(fetchState(multiLineStateCountrySplitFilter[3]));
                        }
                    }
                }
            }else{
                newvalue["city"]= multiLinePostal;
            }
        }
        setValues({
            ...values,
            ...newvalue
        })
        }else{
            setValues({
                ...values,
                [name]: value
            })
            validate({ [name]: value })
        }
    }
    const dispatchShipmentTypeInputChangeCallback = (name, value) => {
        setValues({
            ...values,
            [name]: value
        })
        validate({ [name]: value })
    }
    const dispatchCheckboxChangeCallback = (name, value) => {
        setValues({
            ...values,
            [name]: value
        })
        validate({ [name]: value })
    }
    
    const dispatchSenderAddressCallback = (id) => {
        setSenderAddressObjectId(id)
        if (addresssender && addresssender.data) {
            addresssender.data.map((item) => {
                if (item && item._id && item._id === id) {
                    setValues({
                        ...values,
                        ['preferred_sender_id']: id,
                        sender_name: item.sender_name.trim(),
                        sender_company: item.sender_company && item.sender_company!=='' ? item.sender_company :"",
                        sender_email: item.sender_email,
                        sender_phone: item.sender_phone && item.sender_phone!=="" ? item.sender_phone :"",
                        sender_address: item.sender_address,
                        sender_address2: item.sender_address2 && item.sender_address2 ? item.sender_address2 : "",
                        sender_city: item.sender_city,
                        sender_postal_code: item.sender_postal_code,
                        sender_province_code: item.sender_state_code,
                        sender_country_code: item.sender_country_code
                    })
                }
            })
        }
        setErrors({ "preferred_sender_id": "" })
    }

    const dispatchLineItemCallback = (items) => {
        setLineItemId(items)
    }
    const getLineItemWeightUnit = (items) => {
        let totalLineItems=items.length;
        let lineItemWeight="";
        let lineItemWeightUnit="";
        totalLineItems>0 && lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.map((lineItemsWeightData) => {
            if(totalLineItems in lineItemsWeightData.line_items_weight){
                lineItemWeightUnit=lineItemsWeightData.line_item_weight_unit
            }
        })
        return lineItemWeightUnit
    }

    const getLineItemWeight = (items) => {
        let totalLineItems=items.length;
        let lineItemWeight="";
        totalLineItems>0 && lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.map((lineItemsWeightData) => {
            if(totalLineItems in lineItemsWeightData.line_items_weight){
                lineItemWeight=parseFloat(lineItemsWeightData.line_items_weight[totalLineItems-1]).toFixed(2)
            }
        })
        return lineItemWeight
    }

    const chooseMeasurement = (lineItemAcutualWeight,insurance_amount) => {
        if (box && box.data && box.data.length != 0) {
            box.data.map((item) => {
                if (item && item.box_default && item.box_default === true) {
                    setDefaultBoxDim({
                        "length": parseFloat(item.box_length).toFixed(2),
                        "width": parseFloat(item.box_width).toFixed(2),
                        "height": parseFloat(item.box_height).toFixed(2),
                        "dimension_unit": item.box_length_unit,
                        "actual_weight": (lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.length>0 && customLineItems.length >0) ? getLineItemWeight(customLineItems) : (lineItemAcutualWeight!==0 && item.use_actual_weight && item.use_actual_weight===true) ? parseFloat(lineItemAcutualWeight).toFixed(2) :parseFloat(item.box_weight).toFixed(2),
                        "weight_unit": (lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.length>0 && customLineItems.length >0) ? getLineItemWeightUnit(customLineItems) : item.box_weight_unit,
                        "use_actual_weight":item.use_actual_weight && item.use_actual_weight===true? item.use_actual_weight:false,
                        "choosenmeasurement": item._id,
                        "insurance_amount": profile && profile.profile && profile.profile.is_order_value_as_insurance && profile.profile.is_order_value_as_insurance===true ? insurance_amount : "100"
                    })
                }
            })
        }
    }
    const productlineitemsetfunc = (items) => {
        if (items) {
            let productLineItem = []
            items && items.map((item) => {
                if (item) {
                    let product_id = 1;
                    if(item && item.product_id && item.product_id != ""){
                        product_id = item.product_id;
                    }else if(item && item.sku && item.sku != ""){
                        product_id = item.sku;
                    }
                    productLineItem.push({
                        "line_item_id": (item && item.line_item_id && item.line_item_id != "") ? item.line_item_id : "1",
                        "product_id": product_id,
                        "product_desc": (item && item.product_desc && item.product_desc != "") ? item.product_desc : "Product 1",
                        "product_url": (item && item.product_image && item.product_image != "") ? item.product_image : "https://www.shippingchimp.com/",
                        "product_price": (item && item.product_price && item.product_price != "") ? item.product_price : "100",
                        "hs_tariff_code": (item && item.hs_tariff_code && item.hs_tariff_code != "") ? item.hs_tariff_code : "",
                        "hs_tariff_code_country": (item && item.hs_tariff_code_country && item.hs_tariff_code_country != "") ? item.hs_tariff_code_country : "",
                        "origin_country_code": (item && item.origin_country_code && item.origin_country_code != "") ? item.origin_country_code : "",
                        "quantity": (item && item.quantity && item.quantity != "") ? item.quantity : 1
                    })
                }
            })
            return productLineItem
        }
    }
    const formAutoRateFetchValuesfunc = (newOrderFormData,length,width,height,box_weight,actual_weight,weight_unit,dimension_unit,dimensions,insurance_amount,preferred_sender,address_formatted,address_formatted2,shipment_type) => {
            let isRateAutovalues={}
                isRateAutovalues={
                     "name": (newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.name)
                         ? newOrderFormData.shipping_address.name : "",
                     "company": (newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.company)
                         ? newOrderFormData.shipping_address.company : "",
                     "email": (newOrderFormData && newOrderFormData.customer && newOrderFormData.customer.email)
                         ? newOrderFormData.customer.email : (profile && profile.profile && profile.profile.default_customer_email) ? profile.profile.default_customer_email : profile.profile.email,
                     "address": address_formatted,
                     "address2": address_formatted2,
                     "city": (newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.city)
                         ? newOrderFormData.shipping_address.city : "",
                     "postal_code": (newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.zip)
                         ? newOrderFormData.shipping_address.zip.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '') : "",
                     "province_code": (newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.province_code)
                         ? newOrderFormData.shipping_address.province_code
                         : (newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.province_code)
                             ? newOrderFormData.shipping_address.province_code : "",
                     "country_code": (newOrderFormData && newOrderFormData.shipping_address
                         && newOrderFormData.shipping_address.country_code) ? newOrderFormData.shipping_address.country_code : "",
                     "phone": (newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.phone)
                         ? newOrderFormData.shipping_address.phone : "",
                     "sender_reference_no":(newOrderFormData && newOrderFormData.reference && newOrderFormData.reference.no)
                     ? newOrderFormData.reference.no : "",
                     "length": length,
                     "width": width,
                     "height": height,
                     "box_weight": box_weight,
                     "actual_weight": actual_weight,
                     "weight_unit": weight_unit,
                     "dimension_unit": dimension_unit,
                     "dimensions": dimensions,
                     "choosemeasurement": "custom",
                     "insurance_amount": insurance_amount,
                     "preferred_sender_id": preferred_sender,
                     "shipment_type":shipment_type
                }
                 setErrors({})
                 if(length!=0){
                    let dimensionObjectSet={
                        "weight":actual_weight,
                        "package_dimension":length+"x"+width+"x"+height
                    }
                    Object.assign(isRateAutovalues,dimensionObjectSet)
                 }
                if(newOrderFormData && newOrderFormData.line_items && newOrderFormData.line_items.length!=0){
                    let productLineItem= productlineitemsetfunc(newOrderFormData && newOrderFormData.line_items)
                    productLineItem=JSON.stringify(productLineItem)
                    let productlineitemset={}
                    productlineitemset={
                        "line_items":productLineItem
                    }
                    Object.assign(isRateAutovalues,productlineitemset)
                }else{
                    dimension_data["line_items"] = [];
                }
                let email = isRateAutovalues.email;
                if (isRateAutovalues.email === '') {
                     email = profile.profile.email
                }
                let dimension_data = {}
                if(isRateAutoEnabled!=true){
                    let dimension_data = {}
                        dimension_data = getConsolidateDimensions()
                }
                 if(isReturnOrder){
                     dimension_data["is_return"] = true
                }
                dimension_data["email"] = email
                dimension_data["request_medium"] = "UI"
                if(profile && profile.profile && profile.profile.hide_rate_drawer === true){
                    dimension_data["recommended_rate_only"] = true
                    setRateDrawervisible(false)
                    setIsRateShown(true)
                }else{
                    dimension_data["recommended_rate_only"] = false
                    setRateDrawervisible(true)
                    setIsRateShown(false)
                }
                dimension_data["request_cheapest_carrier"] = (profile && profile.profile && profile.profile.request_cheapest_service && profile.profile.request_cheapest_service === true) ? true : false
                dimension_data["standard_service_only"] = (profile && profile.profile && profile.profile.standard_service_only && profile.profile.standard_service_only === true) ? true : false
                Object.assign(isRateAutovalues, dimension_data)
            return isRateAutovalues
    }

    const converToWeightUnit = (weight, actual_weight_unit, weight_unit) => {
        if (actual_weight_unit.toLowerCase() == weight_unit.toLowerCase()){
            return weight;
        }else{
            if(actual_weight_unit.toLowerCase() == "lb" && weight_unit.toLowerCase() == "kg"){
                weight = weight/2.205;
            }else if(actual_weight_unit.toLowerCase() == "lb" &&  weight_unit.toLowerCase() == "g"){
                weight = weight * 453.6;
            }else if(actual_weight_unit.toLowerCase() == "kg" &&  weight_unit.toLowerCase() == "g"){
                weight = weight * 1000;
            }else if(actual_weight_unit.toLowerCase() == "kg" &&  weight_unit.toLowerCase() == "lb"){
                weight = weight * 2.205;
            }else if(actual_weight_unit.toLowerCase() == "g" &&  weight_unit.toLowerCase() == "kg"){
                weight = weight / 1000;
            }else if(actual_weight_unit.toLowerCase() == "g" &&  weight_unit.toLowerCase() == "lb"){
                weight = weight / 453.6;
            }
            return parseFloat(weight).toFixed(2);
        }

    }

    useEffect(() => {
        setCreateButtonDisable(false)
        if (newOrderFormData !== '') {
            if (!isDuplicateOrder && !isReturnOrder) {
                setdocIdCreate(newOrderFormData && newOrderFormData._id)
            } else {
                setdocIdCreate(generateCustomRef())
            }

            // Standard Init
            let insurance_amount = "100"
            let preferred_sender = ""
            let shipment_type = "PACKAGE"
            let is_signature_required = (profile && profile.profile && profile.profile.is_signature_required === true)
            let is_deliver_to_po_address = (profile && profile.profile && profile.profile.is_deliver_to_po_address === true)
            let is_leave_at_door_shipment = (profile && profile.profile && profile.profile.is_leave_at_door_shipment === true)
            let lineItemAcutualWeight = 0
            let sender_name = "", sender_company = "", sender_email = "", sender_phone = "", sender_address = "", sender_address2 = "", sender_city = "", sender_postal_code = "", sender_province_code = "", sender_country_code = ""
            let vat_no = "", delivery_notes = ""

            // 1. Insurance Logic
            if (profile && profile.profile && profile.profile.is_order_value_as_insurance) {
                let customOrderTotalPrice = newOrderFormData && newOrderFormData.order && newOrderFormData.order.total_price ? Number(newOrderFormData.order.total_price) : 0;
                let orderValueCurrency = newOrderFormData && newOrderFormData.order && newOrderFormData.order.currency ? newOrderFormData.order.currency : "CAD";
                if (orderValueCurrency === 'USD') customOrderTotalPrice = parseFloat(1.35 * customOrderTotalPrice).toFixed(2);
                insurance_amount = customOrderTotalPrice > 0 && customOrderTotalPrice <= 300 ? customOrderTotalPrice : customOrderTotalPrice > 300 ? profile.profile.max_insurance_value : "100"
                setCustomInsuranceAmount(insurance_amount)
            }

            // 2. Weight Aggregation
            if (newOrderFormData && newOrderFormData.line_items) {
                newOrderFormData.line_items.map((item) => {
                    lineItemAcutualWeight = (item && item.actual_weight) ? parseFloat(lineItemAcutualWeight) + parseFloat(item.actual_weight) : parseFloat(lineItemAcutualWeight);
                })
                setLineItemActualWeightState(lineItemAcutualWeight)
            }
            // Access the first object in the label array safely
            const firstLabel = newOrderFormData?.label?.[0] || {};
            // This block only executes if firstLabel is a valid, non-empty object
            if (firstLabel && Object.keys(firstLabel).length > 0) {
                is_signature_required = firstLabel.is_signature_required ?? false;
                is_deliver_to_po_address = firstLabel.is_deliver_to_po_address ?? false;
                is_leave_at_door_shipment = firstLabel.is_leave_at_door_shipment ?? false;
                delivery_notes = firstLabel.delivery_notes || "";
                vat_no = firstLabel.vat_no || "";
                shipment_type = firstLabel.shipment_type || "PACKAGE";
            }
            // Helper to check if shipment exists in new JSON structure
            const hasNoTracking = !newOrderFormData.line_items?.some(item => item.tracking_number && item.tracking_number !== "");
            // 3. YOUR SPECIFIC LOGIC PATHS START HERE
            if (newOrderFormData && newOrderFormData.product_info && newOrderFormData.product_info.dimensions && hasNoTracking) {
                setDefaultBoxDim({
                    "length": newOrderFormData.product_info.dimensions.length > 0 ? parseFloat(newOrderFormData.product_info.dimensions.length).toFixed(2) : 0,
                    "width": newOrderFormData.product_info.dimensions.width > 0 ? parseFloat(newOrderFormData.product_info.dimensions.width).toFixed(2) : 0,
                    "height": newOrderFormData.product_info.dimensions.height > 0 ? parseFloat(newOrderFormData.product_info.dimensions.height).toFixed(2) : 0,
                    "actual_weight": newOrderFormData.product_info.actual_weight > 0 ? parseFloat(newOrderFormData.product_info.actual_weight).toFixed(2) : 0,
                    "dimension_unit": newOrderFormData.product_info.dimensions.height_unit || "",
                    "weight_unit": newOrderFormData.product_info.weight_unit || "",
                    "choosenmeasurement": 0,
                    "insurance_amount": (profile?.profile?.is_order_value_as_insurance) ? insurance_amount : (newOrderFormData.product_info.insurance_amount || "100")
                })
            } else if (newOrderFormData && newOrderFormData.shipping_address?.country_code && newOrderFormData.order?.total_price && boxValues.length > 0 && (newOrderFormData.shipping_address.country_code === 'US' || newOrderFormData.shipping_address.country_code === 'GB')) {
                let orderTotalPrice = newOrderFormData.order.total_price;
                let boxTag = '';
                if (newOrderFormData.shipping_address.country_code == 'US') {
                    if (orderTotalPrice < 20) boxTag = 1;
                    else if (orderTotalPrice < 35) boxTag = 2;
                    else boxTag = 3;
                } else if (newOrderFormData.shipping_address.country_code == 'GB') {
                    boxTag = orderTotalPrice < 15 ? 4 : 5;
                }
                boxValues.map((item) => {
                    if (boxTag == item.box_tag) {
                        setDefaultBoxDim({
                            "length": parseFloat(item.box_length).toFixed(2),
                            "width": parseFloat(item.box_width).toFixed(2),
                            "height": parseFloat(item.box_height).toFixed(2),
                            "actual_weight": parseFloat(item.box_weight).toFixed(2),
                            "dimension_unit": item.box_length_unit,
                            "weight_unit": item.box_weight_unit,
                            "choosenmeasurement": 0,
                            "insurance_amount": (profile?.profile?.is_order_value_as_insurance) ? insurance_amount : "100"
                        })
                    }
                })
            } else {
                if (newOrderFormData && newOrderFormData.line_items && newOrderFormData.line_items.length !== 0) {
                    let skucheck = []
                    newOrderFormData.line_items.map((item) => {
                        let newSku = (item && item.sku) ? item.sku.toUpperCase() : "";
                        if (profile && profile.profile && !profile.profile.multiply_weight_with_quantity) {
                            let quantity = item.quantity || 1;
                            newSku = newSku + "-" + quantity
                        }
                        if (item.sku && !skucheck.includes(newSku)) skucheck.push(newSku)
                    })
                    setSkus(skucheck)
                    if (skucheck.length == 1 && skucheck[0] in customboxDimensions) {
                        let total_quantity = newOrderFormData.total_quantity || 1
                        setDefaultBoxDim({
                            'length': customboxDimensions[skucheck[0]].box_length,
                            'width': customboxDimensions[skucheck[0]].box_width,
                            'height': customboxDimensions[skucheck[0]].box_height,
                            'actual_weight': profile?.profile?.multiply_weight_with_quantity ? total_quantity * customboxDimensions[skucheck[0]].box_weight : customboxDimensions[skucheck[0]].box_weight,
                            'weight_unit': customboxDimensions[skucheck[0]].box_weight_unit,
                            'dimension_unit': customboxDimensions[skucheck[0]].box_width_unit,
                            "choosenmeasurement": 0,
                            "insurance_amount": (profile?.profile?.is_order_value_as_insurance) ? insurance_amount : "100"
                        })
                    } else if (hasNoTracking) {
                        chooseMeasurement(lineItemAcutualWeight, insurance_amount);
                    }
                }
            }

            // 4. Address Split Logic
            let addr_f = '', addr_f2 = '';
            if (newOrderFormData.shipping_address?.address1) {
                let a1 = newOrderFormData.shipping_address.address1;
                if (a1.length > 35) {
                    let splitIdx = a1.lastIndexOf(' ', 35);
                    let finalSplit = splitIdx > 0 ? splitIdx : 35;
                    addr_f = a1.slice(0, finalSplit);
                    addr_f2 = a1.slice(finalSplit).trim();
                } else {
                    addr_f = a1;
                }
            }
            if (newOrderFormData.shipping_address?.address2) {
                addr_f2 = addr_f2 !== "" ? addr_f2 + " " + newOrderFormData.shipping_address.address2 : newOrderFormData.shipping_address.address2;
            }

            // 5. Existing Shipment Data Extraction (Mapping from line_items array)
            let multiPackageFieldsCustom = [];
            let processedShipmentIds = new Set(); // To prevent duplicates for same shipment

            newOrderFormData.line_items.forEach((item) => {
                const ship = item.shipment;
                
                // Only process if shipment exists AND we haven't processed this specific shipment_id yet
                if (!isShipmentCreationFlow && ship && ship.shipment_id && !processedShipmentIds.has(ship.shipment_id)) {
                    
                    // Match tracking or handle multi-piece
                    const isTarget = (choosenTrackingNumber === 0) || 
                                     (ship.tracking_numbers?.includes(choosenTrackingNumber)) || 
                                     (ship.is_multi_piece && choosenTrackingNumber === 0);

                    if (isTarget) {
                        // Mark this shipment ID as processed so other line items sharing this shipment are skipped
                        processedShipmentIds.add(ship.shipment_id);

                        // shipment_type = ship.shipment_type || "PACKAGE";
                        // is_signature_required = ship.is_signature_required ?? is_signature_required;
                        // delivery_notes = ship.delivery_notes || "";
                        // vat_no = item.vat_no || "";

                        const pInfos = Array.isArray(ship.product_info) ? ship.product_info : [ship.product_info];
                        pInfos.forEach(p => {
                            if (p.dimensions) {
                                multiPackageFieldsCustom.push({
                                    "length": parseFloat(p.dimensions.length || 0).toFixed(2),
                                    "width": parseFloat(p.dimensions.width || 0).toFixed(2),
                                    "height": parseFloat(p.dimensions.height || 0).toFixed(2),
                                    "dimension_unit": p.dimensions.length_unit || "in",
                                    "actual_weight": parseFloat(p.actual_weight || 0).toFixed(2),
                                    "weight_unit": p.weight_unit || "lb",
                                    "choosenmeasurement": 0,
                                    "insurance_amount": p.insurance_amount || insurance_amount
                                });
                            }
                        });
                    }
                }
            });

            if (multiPackageFieldsCustom.length > 0) {
                setMultiPackageFields(multiPackageFieldsCustom);
            }
            const billing = newOrderFormData.billing_address;
            if (newOrderFormData && newOrderFormData.shipment && newOrderFormData.shipment.tracking && Object.keys(newOrderFormData.shipment.tracking).length != 0) {
                for (var key in newOrderFormData.shipment.tracking) {
                    if (newOrderFormData.shipment.tracking[key] && newOrderFormData.shipment.tracking[key].label && newOrderFormData.shipment.tracking[key].label.shipment_type) {
                        shipment_type=newOrderFormData.shipment.tracking[key].label.shipment_type
                        }
                    if (newOrderFormData.shipment.tracking[key] && newOrderFormData.shipment.tracking[key].address && newOrderFormData.shipment.tracking[key].address.sender) {
                        preferred_sender=newOrderFormData.shipment.tracking[key].address.sender.id
                        setSenderAddressObjectId(preferred_sender)
                            if (addresssender && addresssender.data && preferred_sender!=='') {
                                addresssender.data.map((item) => {
                                    if (item && item._id && item._id===preferred_sender) {
                                        preferred_sender=item._id
                                        sender_name=item.sender_name.trim()
                                        sender_company=item.sender_company && item.sender_company!=='' ? item.sender_company :""
                                        sender_email=item.sender_email
                                        sender_phone=item.sender_phone && item.sender_phone!=="" ? item.sender_phone :""
                                        sender_address= item.sender_address
                                        sender_address2=item.sender_address2 && item.sender_address2 ? item.sender_address2 : ""
                                        sender_city= item.sender_city
                                        sender_postal_code=item.sender_postal_code
                                        sender_province_code=item.sender_state_code
                                        sender_country_code=item.sender_country_code
                                    }else{
                                        sender_name=newOrderFormData.shipment.tracking[key].address.sender.name
                                        sender_company=newOrderFormData.shipment.tracking[key].address.sender.company
                                        sender_email=newOrderFormData.shipment.tracking[key].address.sender.email
                                        sender_phone=newOrderFormData.shipment.tracking[key].address.sender.phone
                                        sender_address= newOrderFormData.shipment.tracking[key].address.sender.address1
                                        sender_address2=newOrderFormData.shipment.tracking[key].address.sender.address2
                                        sender_city=newOrderFormData.shipment.tracking[key].address.sender.city
                                        sender_postal_code=newOrderFormData.shipment.tracking[key].address.sender.zip
                                        sender_province_code=newOrderFormData.shipment.tracking[key].address.sender.province_code
                                        sender_country_code=newOrderFormData.shipment.tracking[key].address.sender.country_code
                                    }
                                })
                            }else{
                                sender_name=newOrderFormData.shipment.tracking[key].address.sender.name
                                sender_company=newOrderFormData.shipment.tracking[key].address.sender.company
                                sender_email=newOrderFormData.shipment.tracking[key].address.sender.email
                                sender_phone=newOrderFormData.shipment.tracking[key].address.sender.phone
                                sender_address= newOrderFormData.shipment.tracking[key].address.sender.address1
                                sender_address2=newOrderFormData.shipment.tracking[key].address.sender.address2
                                sender_city=newOrderFormData.shipment.tracking[key].address.sender.city
                                sender_postal_code=newOrderFormData.shipment.tracking[key].address.sender.zip
                                sender_province_code=newOrderFormData.shipment.tracking[key].address.sender.province_code
                                sender_country_code=newOrderFormData.shipment.tracking[key].address.sender.country_code
                            }
                        break
                        }
                    }
                    let shipmentLength = Object.keys(newOrderFormData.shipment.tracking).length
                    for (var key in newOrderFormData.shipment.tracking) {
                        if (newOrderFormData.shipment.tracking[key] &&  (shipmentLength == 1 || (shipmentLength > 1 && choosenTrackingNumber == key))) {
                            if (newOrderFormData.shipment.tracking[key] && newOrderFormData.shipment.tracking[key].label && typeof newOrderFormData.shipment.tracking[key].label.is_signature_required !== "undefined") {
                                is_signature_required=newOrderFormData.shipment.tracking[key].label.is_signature_required
                            }
                            if (newOrderFormData.shipment.tracking[key] && newOrderFormData.shipment.tracking[key].label && typeof newOrderFormData.shipment.tracking[key].label.is_deliver_to_po_address !== "undefined") {
                                is_deliver_to_po_address=newOrderFormData.shipment.tracking[key].label.is_deliver_to_po_address
                            }
                            if (newOrderFormData.shipment.tracking[key] && newOrderFormData.shipment.tracking[key].address && newOrderFormData.shipment.tracking[key].address.receiver) {
                                vat_no=newOrderFormData.shipment.tracking[key].address.receiver.vat_no
                            }
                            if (newOrderFormData.shipment.tracking[key] && newOrderFormData.shipment.tracking[key].label && newOrderFormData.shipment.tracking[key].label.delivery_notes) {
                                delivery_notes=newOrderFormData.shipment.tracking[key].label.delivery_notes
                            }
                        }
                    }    
            }else{
                if (addresssender && addresssender.data) {
                    addresssender.data.map((item) => {
                        if (item && item.default & item.default===true) {
                            preferred_sender=item._id
                            sender_name=item.sender_name.trim()
                            sender_company=item.sender_company && item.sender_company!=='' ? item.sender_company :""
                            sender_email=item.sender_email
                            sender_phone=item.sender_phone && item.sender_phone!=="" ? item.sender_phone :""
                            sender_address= item.sender_address
                            sender_address2=item.sender_address2 && item.sender_address2 ? item.sender_address2 : ""
                            sender_city= item.sender_city
                            sender_postal_code=item.sender_postal_code
                            sender_province_code=item.sender_state_code
                            sender_country_code=item.sender_country_code
                        }
                    })
                }
            }
            // if (billing && billing.name) {
            //     // Scenario A: billing_address exists in JSON
            //     sender_name = (billing.name || "").trim();
            //     sender_company = billing.company || "";
            //     sender_email = billing.email || "";
            //     sender_phone = billing.phone || "";
            //     sender_address = billing.address1 || "";
            //     sender_address2 = billing.address2 || "";
            //     sender_city = billing.city || "";
            //     sender_postal_code = billing.zip || "";
            //     sender_province_code = billing.province_code || "";
            //     sender_country_code = billing.country_code || "";
            //     // Use the billing id if it matches a sender ID, otherwise keep current preferred_sender
            //     preferred_sender = billing.id || preferred_sender;
            // }
            // setSenderAddressObjectId(preferred_sender);
            // 6. Final Values Set
            setValues({
                ...initialFValues,
                choosemeasurement: "custom",
                insurance_amount,
                preferred_sender_id: preferred_sender,
                is_signature_required,
                is_deliver_to_po_address,
                is_leave_at_door_shipment,
                // Recipient Fields
                name: newOrderFormData.shipping_address?.name?.trim() || "",
                company: newOrderFormData.shipping_address?.company?.trim() || "",
                email:profile?.profile?.default_customer_email 
                || newOrderFormData?.customer?.email 
                || newOrderFormData?.shipping_address?.email 
                || profile?.profile?.email 
                || "",
                address: addr_f.trim(),
                address2: addr_f2.trim(),
                city: newOrderFormData.shipping_address?.city || "",
                postal_code: newOrderFormData.shipping_address?.zip?.replace(/[^a-zA-Z0-9]/g, '') || "",
                province_code: newOrderFormData?.shipping_address?.province_code || newOrderFormData?.shipping_address?.province || "",
                country_code: newOrderFormData.shipping_address?.country_code || "",
                phone: newOrderFormData.shipping_address?.phone || "",
                sender_reference_no: newOrderFormData.reference?.no || "",
                shipment_type,
                // Sender Fields (Populated from Logic above)
                sender_name, 
                sender_company, 
                sender_email, 
                sender_phone, 
                sender_address, 
                sender_address2, 
                sender_city, 
                sender_postal_code, 
                sender_province_code, 
                sender_country_code,
                vat_no, 
                delivery_notes
            });

            // Return Order Specific Override
            if (isReturnOrder) {
                setValues({
                    ...values,
                    // Ensure the ID is reset for custom return sender
                    shipment_type,
                    vat_no, 
                    delivery_notes,
                    is_signature_required,
                    is_deliver_to_po_address,
                    is_leave_at_door_shipment
                });
            }
        } else {
            setdocIdCreate(generateCustomRef());
            setCustomLineItems([]);
            chooseMeasurement(0, 100);
        }
        if (newOrderFormData) {
            // 1. Check if nested order.id exists, otherwise check for flat order_id
            const idToDisplay = (newOrderFormData.order && newOrderFormData.order.id) 
                ? newOrderFormData.order.id 
                : newOrderFormData.order_id;

            if (idToDisplay) {
                setOrderId("# " + idToDisplay);
            }
        }
    }, [newOrderFormData, visible]);


    const dispatchCountryCallback = (id) => {
        setValues({
            ...values,
            ['country_code']: id
        })
        setErrors({ "country_code": "" })
        dispatch(fetchState(id));
    }


    const dispatchSenderCountryCallback = (id) => {
        setValues({
            ...values,
            ['sender_country_code']: id
        })
        setErrors({ "country_code": "" })
        dispatch(fetchMultiStates(id));
    }
    const getConsolidateDimensions = () => {
        let response = {
            "package_dimension": "",
            "dimension_unit": "",
            "weight": "",
            "weight_unit": "",
            "insurance_amount": ""
        }
        multiPackageFields.forEach((data) => {
            let dimension = parseFloat(data["length"]).toFixed(2) + "x" + parseFloat(data["width"]).toFixed(2) + "x" + parseFloat(data["height"]).toFixed(2)
            response["package_dimension"] = (response["package_dimension"] == "") ? dimension : response["package_dimension"] + "," + dimension
            response["dimension_unit"] = (response["dimension_unit"] == "") ? data["dimension_unit"] : response["dimension_unit"] + "," + data["dimension_unit"]
            response["weight"] = (response["weight_unit"] == "") ? parseFloat(data["actual_weight"]).toFixed(2): response["weight"] + "," + parseFloat(data["actual_weight"]).toFixed(2)
            response["weight_unit"] = (response["weight_unit"] == "") ? data["weight_unit"] : response["weight_unit"] + "," + data["weight_unit"]
            response["insurance_amount"] = (response["insurance_amount"] == "") ? data["insurance_amount"] : response["insurance_amount"] + "," + data["insurance_amount"]
        })
        return response
    }

    function generateCustomRef() {
        // Generate a 24-character hex string
        const randomHex = [...Array(24)]
          .map(() => Math.floor(Math.random() * 16).toString(16))
          .join('');
      
        // Get current datetime in YYYYMMDDHHmmss format
        const now = new Date();
        const datetime =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, '0') +
          String(now.getDate()).padStart(2, '0') +
          String(now.getHours()).padStart(2, '0') +
          String(now.getMinutes()).padStart(2, '0') +
          String(now.getSeconds()).padStart(2, '0');
        // Combine everything
        return `SCREF${randomHex}${datetime}`;
      }

    const handleSubmit = (e, value) => {
        setShowFieldErrors(true)
        if(isRateAutoEnabled!=true){
            e.preventDefault()
        }
        // 1. Identify the country
        const countryToCheck = isReturnOrder 
            ? (values.sender_country_code || "") 
            : (values.country_code || "");

        const upperCountry = countryToCheck.toString().toUpperCase().trim();
        const isCanada = upperCountry === "CA" || upperCountry === "CANADA";

        // 2. Logic for Canada Bypass:
        // It is ONLY a "Canada Order" (bypassing item selection) 
        // IF it is Canada AND it is NOT a Shipment Creation Flow.
        const canBypassItems = isCanada && !isShipmentCreationFlow;

        // UPDATED CONDITION:
        // Pass if:
        // - Field validation passes AND
        // - (It's a non-Creation Canada order OR at least one item is selected)
        if (validate() && (canBypassItems || lineItemId.length > 0)) {
            let apikey = (profile.profile.api_token) ? profile.profile.api_token : "";
            let email = values.email;
            let name=values.name;
            let city=values.city;
            let address = values.address;
            let address2 = values.address2;
            let is_signature_required=values.is_signature_required;
            let preferred_sender_id=values.preferred_sender_id;
            if (values.email === '') {
                email = profile.profile.email
            }
            if (values.name !== '') {
                name = values.name.replaceAll(/-/g, ' ').replaceAll(/[’`']/g, '');
            }
            if (values.city !== '') {
                city = values.city.replaceAll(/-/g, ' ').replaceAll(/[’`']/g, '');
            }
            if (values.address !== '') {
                address = values.address.replaceAll(/[’`]/g, '');
            }
            if (values.address2 !== '') {
                address2 = values.address2.replaceAll(/[’`]/g, '');
            }
            if (values.preferred_sender_id !== '') {
                preferred_sender_id = ""
            }
            let dimension_data = {}
            dimension_data = getConsolidateDimensions()
            dimension_data["total_quantity"] = newOrderFormData && newOrderFormData.total_quantity ? newOrderFormData && newOrderFormData.total_quantity :""
            dimension_data["no_of_line_items"] = newOrderFormData && newOrderFormData.no_of_line_items ? newOrderFormData && newOrderFormData.no_of_line_items :""
            dimension_data["skus"] = skus && skus.length!==0 ? skus:[]
            if(isReturnOrder){
                delete values['is_signature_required'];
                dimension_data["is_return"] = true
            }else{
                dimension_data["is_signature_required"] = is_signature_required
            }
            let templineItemIds = [...lineItemId]; // Strictly use selected IDs from state
            dimension_data["line_items"] = [];

            if (customLineItems.length != 0) {
                let tempItem = [];
                
                // REMOVE the "else" logic that was automatically adding all items 
                // when lineItemId.length was 0.
                customLineItems.forEach((item) => {
                    if (templineItemIds.includes(String(item.line_item_id.toString()))) {
                        if (tempItem.length < 20) {
                            tempItem.push(item);
                        }
                    }
                });
                
                // If no items are selected, templineItemIds remains [], as desired.
                setLineItemId(templineItemIds);
                // dimension_data["line_items"] = tempItem; // This ensures payload line_items matches selected items
            }
          
            if (value === 'FETCH') {
                let order_id_check=""
                order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
                    ? newOrderFormData.order.id : ""
                dimension_data["email"] = email
                dimension_data["name"] = name
                dimension_data["city"] = city
                dimension_data["address"] = address
                dimension_data["address2"] = address2
                dimension_data["preferred_sender_id"] = preferred_sender_id
                dimension_data["request_medium"] = "UI"
                dimension_data["is_sender_address_exists"] = true
                dimension_data["order_value"] = newOrderFormData && newOrderFormData.order && newOrderFormData.order.total_price && newOrderFormData.order.total_price!=='' ?  newOrderFormData.order.total_price : 0
                if(newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.is_commercial && newOrderFormData.shipping_address.is_commercial===true){
                     dimension_data["is_commercial"] = "yes"
                }
                if(profile && profile.profile && profile.profile.hide_rate_drawer === true){
                    dimension_data["recommended_rate_only"] = true
                    setRateDrawervisible(isReturnOrder===true ? true : false)
                    setIsRateShown(isReturnOrder===true ? false : true)
                }else{
                    dimension_data["recommended_rate_only"] = false
                    setRateDrawervisible(true)
                    setIsRateShown(false)
                }
                let item_reference_id=""
                if(isReturnOrder){
                    let jsonStringitemids = JSON.stringify(templineItemIds);
                    item_reference_id=docIdCreate
                    dimension_data["item_reference_id"]=item_reference_id
                    dimension_data["item_ids"]=jsonStringitemids
                }else if(isDuplicateOrder){
                    let jsonStringitemids = JSON.stringify(templineItemIds);
                    item_reference_id=docIdCreate
                    dimension_data["item_reference_id"]=item_reference_id
                    dimension_data["item_ids"]=jsonStringitemids
                }else{
                    item_reference_id=(newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : docIdCreate
                    let jsonStringitemids = JSON.stringify(templineItemIds);
                    dimension_data["item_reference_id"]=item_reference_id
                    dimension_data["item_ids"]=jsonStringitemids
                }
                setIsFailedLabelPrinted(true)
                dimension_data["quantity"] = (newOrderFormData && newOrderFormData.line_items && newOrderFormData.line_items.length !== 0 && newOrderFormData.line_items[0].quantity) ? newOrderFormData.line_items[0].quantity : 1
                dimension_data["subuser_id"] = profile && profile.profile && profile.profile.id
                dimension_data["request_cheapest_carrier"] = (profile && profile.profile && profile.profile.request_cheapest_service && profile.profile.request_cheapest_service === true) ? true : false
                dimension_data["standard_service_only"] = (profile && profile.profile && profile.profile.standard_service_only && profile.profile.standard_service_only === true) ? true : false
                Object.assign(values, dimension_data);
                setFormDataValues(values)
                dispatch(doGetRate(reportName,profile.profile.id,order_id_check,values, apikey));
            } else {
                if(value === 'FAILEDGENERATE'){
                    setIsFailedLabelPrinted(false)
                }else{
                    setIsFailedLabelPrinted(true)
                }
                let order_id_check=""
                let document_reference={}
                if(isReturnOrder){
                    order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
                        ? "R"+newOrderFormData.order.id : ""
                    document_reference={
                        "doc_id": "",
                        "order_id": order_id_check,
                        "item_ids": templineItemIds,
                        "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                        "item_reference_id":docIdCreate,
                        "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
                    }
                }else if(isDuplicateOrder){
                    document_reference={
                        "doc_id": "",
                        "order_id": "",
                        "item_ids": templineItemIds,
                        "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                        "item_reference_id":docIdCreate,
                        "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
                    }
                }else{
                    order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
                    ? newOrderFormData.order.id : ""
                    document_reference={
                    "doc_id": (newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : "",
                    "order_id": order_id_check,
                    "item_ids": templineItemIds,
                    "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                    "item_reference_id": (newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : docIdCreate,
                    "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
                    }
                }
                let referenceno = ""
                if(!isDuplicateOrder && newOrderFormData && newOrderFormData.reference && newOrderFormData.reference.no){
                    referenceno = newOrderFormData.reference.no
                }
                dimension_data["referenceno"] = values.sender_reference_no;
                dimension_data["preferred_carrier"] = ""
                dimension_data["preferred_carrier_reference_id"] = ""
                dimension_data["preferred_service"] = ""
                dimension_data["request_cheapest_carrier"] = (profile && profile.profile && profile.profile.request_cheapest_service && profile.profile.request_cheapest_service === true) ? true : false
                dimension_data["standard_service_only"] = (profile && profile.profile && profile.profile.standard_service_only && profile.profile.standard_service_only === true) ? true : false
                dimension_data["email"] = email
                dimension_data["name"] = name
                dimension_data["city"] = city
                dimension_data["address"] = address
                dimension_data["address2"] = address2
                dimension_data["preferred_sender_id"] = preferred_sender_id
                dimension_data["request_medium"] = "UI"
                dimension_data["shipment_created_method"] = "CREATE_SHIPMENT"
                dimension_data["is_sender_address_exists"] = true
                dimension_data["order_value"] = newOrderFormData && newOrderFormData.order && newOrderFormData.order.total_price && newOrderFormData.order.total_price!=='' ?  newOrderFormData.order.total_price : 0
                dimension_data["quantity"] = (newOrderFormData && newOrderFormData.line_items && newOrderFormData.line_items.length !== 0 && newOrderFormData.line_items[0].quantity) ? newOrderFormData.line_items[0].quantity : 1
                dimension_data["reference"] = document_reference
                if(isShipmentCreationFlow && document_reference && document_reference.is_failed_bulk_order && document_reference.is_failed_bulk_order===true){
                    dimension_data["bulk_reference_id"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.reference_id
                    dimension_data["internal_bulk_serial_number"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.serial_number
                    dimension_data["internal_bulk_serial_number_reference"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.serial_number_reference
                }
                if(newOrderFormData && newOrderFormData.shipping_address && newOrderFormData.shipping_address.is_commercial && newOrderFormData.shipping_address.is_commercial===true){
                    dimension_data["is_commercial"] = "yes"
                }
                dimension_data["subuser_id"] = profile && profile.profile && profile.profile.id
                Object.assign(values, dimension_data);
                setIsLabelOpened(false);
                dispatch(dopostDataCreateShipment(reportName,profile && profile.profile && profile.profile.id,order_id_check, values, apikey, meta))
            }
        }else{
            if(isReturnOrder && lineItemId.length === 0 &&  newOrderFormData!=="undefined" && newOrderFormData!==""){
                topRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
    // useEffect
    useEffect(() => {
        if(_.size(country_code.data) === 0 )
            dispatch(fetchCountry());
        if(_.size(addresssender.data) === 0 )
            dispatch(fetchSenderAddress());
        if(_.size(addressbilling.data) === 0 )
            dispatch(fetchAddressBilling());
        if(_.size(box.data) === 0 )
            dispatch(fetchBoxData(false));
        dispatch(fetchProfile())
        dispatch(fetchSkuINfo(""));
    }, [dispatch]);

    useEffect(() => {
        setValues({
            ...values,
            ['is_signature_required']: (profile && profile.profile && typeof profile.profile.is_signature_required !== "undefined") ? profile.profile.is_signature_required :false
        })
    }, [profile]);

    useEffect(() => {
        let boxdimensionTemp={}
        if (box && box.data && box.data.length !== 0) {
            box.data.map((item) => {
                if (item.box_default === true) {
                    setDefaultBoxDim({
                        "length": parseFloat(item.box_length).toFixed(2),
                        "width": parseFloat(item.box_width).toFixed(2),
                        "height": parseFloat(item.box_height).toFixed(2),
                        "dimension_unit": item.box_length_unit,
                        "actual_weight": (lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.length>0 && customLineItems.length >0) ? getLineItemWeight(customLineItems) :parseFloat(item.box_weight).toFixed(2),
                        "weight_unit": (lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.length>0 && customLineItems.length >0) ? getLineItemWeightUnit(customLineItems) : item.box_weight_unit,
                        "use_actual_weight":item.use_actual_weight && item.use_actual_weight===true? item.use_actual_weight:false,
                        "choosenmeasurement": item._id,
                        "insurance_amount": "100"
                    })
                }
                if(!(item.box_name in boxdimensionTemp)){
                    boxdimensionTemp[item.box_name.toUpperCase()]=item
                }
            })
            setcustomboxDimensions(boxdimensionTemp)
        }
        let boxData = box && box.data.filter(function( obj ) {
            return  obj.country;
         });
         setBoxValues(boxData)
    }, [box && box.data]);

    useEffect(() => {
        if(showFieldErrors){
            validate({})
        }
    }, [multiPackageFields])

    useEffect(() => {
      if(lineItemsWeight && lineItemsWeight.data && lineItemsWeight.data.length>0 && customLineItems.length >0){
            let lineitemweight=getLineItemWeight(customLineItems) 
            let lineitemweightUnit=getLineItemWeightUnit(customLineItems) 
            setDefaultBoxDim({
                ...defaultBoxDim,
                "actual_weight": lineitemweight,
                "weight_unit": lineitemweightUnit
            })
      }
    }, [customLineItems])

    useEffect(() => {
        if (addresssender && addresssender.data && isReturnOrder===false) {
            addresssender.data.map((item) => {
                if (item && item.default) {
                    setSenderAddressObjectId(item._id)
                    setValues({
                        ...values,
                        ['preferred_sender_id']: item._id,
                    })
                }
            })
        }
        if (addresssender && addresssender.data && newOrderFormData=="") {
            addresssender.data.map((item) => {
                if (item && item.default && item.default===true && isReturnOrder===false) {
                    setValues({
                        ...values,
                        preferred_sender_id:item._id,
                        sender_name:item.sender_name.trim(),
                        sender_company:item.sender_company && item.sender_company!=='' ? item.sender_company :"",
                        sender_email:item.sender_email,
                        sender_phone:item.sender_phone && item.sender_phone!=="" ? item.sender_phone :"",
                        sender_address: item.sender_address,
                        sender_address2:item.sender_address2 && item.sender_address2 ? item.sender_address2 : "",
                        sender_city: item.sender_city,
                        sender_postal_code:item.sender_postal_code,
                        sender_province_code:item.sender_state_code,
                        sender_country_code:item.sender_country_code
                    })
                }else if(item && item.default && item.default===true && isReturnOrder===true){
                     setValues({
                        ...values,
                        preferred_sender_id:"",
                        sender_name:"",
                        sender_company:"",
                        sender_email:"",
                        sender_phone:"",
                        sender_address: "",
                        sender_address2:"",
                        sender_city: "",
                        sender_postal_code:"",
                        sender_province_code:"",
                        sender_country_code:"",
                        name:item.sender_name.trim(),
                        company:item.sender_company && item.sender_company!=='' ? item.sender_company :"",
                        email:item.sender_email,
                        phone:item.sender_phone && item.sender_phone!=="" ? item.sender_phone :"",
                        address: item.sender_address,
                        address2:item.sender_address2 && item.sender_address2 ? item.sender_address2 : "",
                        city: item.sender_city,
                        postal_code:item.sender_postal_code,
                        country_code:item.sender_country_code,
                        province_code:item.sender_state_code
                    })
                }
            })
        }
    }, [addresssender]);

    useEffect(() => {
        if (orders && orders.notification && orders.notification.messageContent
            && orders.notification.messageContent[0] === 'Shipment Created Successfully' && isLabelOpened == false && rateDrawervisible == false && isLabelPrint== true && isFailedLabelPrinted==true) {
            setPrintUrl(orders && orders.message && orders.message.label_carrier)
            setIsPrinted(false)
            setIsLabelOpened(true);
            ondrawerclose()
        }else if(orders && orders.notification && orders.notification.messageContent
                 && orders.notification.messageContent[0] === 'Shipment Created Successfully' && isFailedLabelPrinted==false) {
                    setCreateButtonDisable(true)
                    ondrawerclose()
                }
    }, [orders]);

    useEffect(() => {
        if (values.province_code) {
            let provincesize = values.province_code.length
            if (provincesize > 2) {
                let provicelowcase = values.province_code = values.province_code.toLowerCase()
                let finalprovince = provicelowcase.charAt(0).toUpperCase() + provicelowcase.slice(1)
                state && state.data.map((key) => {
                    if (finalprovince.toLowerCase() == key.name.toLowerCase()) {
                        setValues({
                            ...values,
                            ['province_code']: key.code,
                        })
                    }
                })
            }
        }
    }, [state]);

    const ondrawerclose = () => {
        // START TRY BLOCK: This "cages" the error so it cannot escape
        // try {
        //     if (window.SessionRecorder && typeof window.SessionRecorder.stop === 'function') {
        //         window.SessionRecorder.stop();
        //     }
        // } 
        // // CATCH BLOCK: If the error happens, it ends up here instead of crashing the UI
        // catch (err) {
        //     console.warn("Caught a SecurityError from the recorder. Ignoring it to close the drawer.");
        // }
        let senderDefault = ''
        // if (addresssender && addresssender.data) {
        //     addresssender.data.map((item) => {
        //         if (item && item.default) {
        //             senderDefault = item._id
        //         }
        //     })
        // }
        setSenderAddressObjectId(senderDefault)
        initialFValues["preferred_sender_id"] = senderDefault
        setValues(initialFValues);
        setNewOrderFormData("");
        setErrors({ name: "" })
        setDimensionsErrors({})
        setDrawer(false)
        onClose(false)
        setShowFieldErrors(false);
        setIsReturnOrder(false)
        setIsRateShown(false)
        dispatch(resetRateState())
        setCustomLineItems([])
        setMultiPackageFields([initialDimValues])
        setOrderId("")
    }
    const formatRate = () => {
        let estimatedRate = "-"
        if(rates && rates.data && Array.isArray(rates.data) && rates.data.length > 0){
            estimatedRate = (rates.data[0] && rates.data[0].total_charges) ? rates.data[0].total_charges : "-"
        }
        return estimatedRate
    }
    return (
        <>
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { width: drawerWidth},
                }}
            >
                 <div ref={topRef} />
                {/* {country_code && country_code.loading === true &&
                    <Loader />
                }
                {orders && orders.loading === true &&
                    <Loader />
                } */}
                <div style={{ padding: "0 30px" }}>
                {(rates && rates.notification && rates.notification.show && rates.notification.show===true) &&
                            <Notification
                                is_open={rates.notification.show}
                                messageType={rates.notification.messageType}
                                messages={rates.notification.messageContent}
                                handleClose={() => dispatch(resetRateState())}
                            />
                        }
                    {(orderNotesData && orderNotesData.notification && orderNotesData.notification.show && orderNotesData.notification.show===true) &&
                            <Notification
                                is_open={orderNotesData.notification.show}
                                messageType={orderNotesData.notification.messageType}
                                messages={orderNotesData.notification.messageContent}
                                handleClose={() => dispatch(resetOrderNoteNotifications())}
                            />
                        }
                    <Card sx={{ margin: '10px 0' }} className="sc--cardhead--details">
                        <CardHeader title={ isShipmentCreationFlow  ? ("Create Shipment " + orderId ): isDuplicateOrder && !isReturnOrder ? ("Duplicate Shipment " + orderId ):((isReturnOrder) ? ("Return Shipment " + orderId ) : "Create new order") } action={
                            <div style={{display:'flex'}}>
                                {newOrderFormData &&
                                    <OrderNote orderid={(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id) ? newOrderFormData.order.id : ""} docid={(newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : ""} notesData={(newOrderFormData && newOrderFormData.order && newOrderFormData.order.note) ? newOrderFormData.order.note : ""} meta={meta}/>
                                }
                                 <WidthMaximize
                                    defaultWidth="90%"
                                    onToggle={(newWidth) => setDrawerWidth(newWidth)}
                                 />
                                <IconButton aria-label="settings" onClick={ondrawerclose}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        } />
                        {(country_code && country_code.loading === true || orders && orders.loading === true || orderNotesData && orderNotesData.loading===true) &&
                            <LinearProgress />
                        }
                        <Divider />
                    </Card>

                    <div className="sc--content--body">
                        <div className="sc--content--card" style={{ margin: 'auto' }}>
                        <Grid
                                container
                                direction='row'
                                spacing={2}
                                alignnewOrderFormDatas="stretch"
                            >
                                <LineItems
                                    lineItems={newOrderFormData && newOrderFormData.line_items}
                                    dispatchLineItemCallback={dispatchLineItemCallback}
                                    isDuplicateOrder={isDuplicateOrder}
                                    customLineItems={customLineItems}
                                    setCustomLineItems={setCustomLineItems}
                                    isReturnOrder={isReturnOrder}
                                    docIdCreate={docIdCreate}
                                    newOrderFormData={newOrderFormData}
                                    reportName={reportName}
                                    isShipmentCreationFlow={isShipmentCreationFlow}
                                    showFieldErrors={showFieldErrors}
                                    activeCountryCode={values?.country_code}
                                    activeSenderCountryCode={values?.sender_country_code}
                                    meta={meta}
                                />


                                <SenderAddressSelect
                                    errors={errors}
                                    addresssender={addresssender}
                                    senderAddressObjectId={senderAddressObjectId}
                                    dispatchSenderAddressCallback={dispatchSenderAddressCallback}
                                    dispatchInputChangeCallback={dispatchInputChangeCallback}
                                    dispatchSenderCountryCallback={dispatchSenderCountryCallback}
                                    values={values}
                                    isReturnOrder={isReturnOrder}
                                    setValues={setValues}
                                />
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                spacing={2}
                                alignnewOrderFormDatas="stretch"
                            >
                                <MultiPackageDimensions
                                    errors={dimensionsErrors}
                                    values={values}
                                    multiPackageFields={multiPackageFields}
                                    onMultiPackageAdd={onMultiPackageAdd}
                                    onMultiPackageRemove={onMultiPackageRemove}
                                    handleMultiPackageDimensionInputChange={handleMultiPackageDimensionInputChange}
                                    dispatchShipmentTypeInputChangeCallback={dispatchShipmentTypeInputChangeCallback}
                                />

                                <RecipientAddressSelect
                                    errors={errors}
                                    values={values}
                                    dispatchInputChangeCallback={dispatchInputChangeCallback}
                                    dispatchCheckboxChangeCallback={dispatchCheckboxChangeCallback}
                                    dispatchCountryCallback={dispatchCountryCallback}
                                    newOrderFormData={newOrderFormData}
                                    setValues={setValues}
                                    isReturnOrder={isReturnOrder}
                                    addresssender={addresssender}
                                    choosenTrackingNumber={choosenTrackingNumber}
                                />
                            </Grid>
                            <div className="sc--form--center" style={{ margin: '30px 0' }}>
                                {(addresssender && addresssender.loading === false)
                                    && addresssender.data && addresssender.data.length === 0 &&
                                    <>
                                        <Button
                                            variant="outlined"
                                            onClick={handleSubmit}
                                            disabled
                                            style={{ border: '1px solid rgba(0, 0, 0, 0.12)', margin: '0 15px' }}
                                        >
                                            <SendIcon style={{ paddingRight: '10px' }} /> Fetch Rates
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            onClick={handleSubmit}
                                            disabled
                                        >
                                            <AddCircleOutlineOutlinedIcon style={{ paddingRight: '10px' }} /> Create + Print
                                        </Button>
                                    </>
                                }
                                {(addresssender && addresssender.loading === false)
                                    && addresssender.data && addresssender.data.length !== 0 &&
                                    <>
                                        <LoadingButton
                                            variant="outlined"
                                            onClick={e => handleSubmit(e, "FETCH")}
                                            style={{ margin: '0 15px' }}
                                            loading={
                                                rates && rates.loading}
                                        >
                                            <SendIcon style={{
                                                paddingRight: '10px'
                                            }} /> Fetch Rates
                                    </LoadingButton>
                                    {(profile && profile.profile && profile.profile.hide_rate_drawer === true) &&
                                    (rates && rates.loading === false) &&
                                    (rates && rates.data && rates.data.length !== 0) && isRateShown &&
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            style={{ marginRight: '15px', cursor: "unset" }}
                                        >
                                            <AttachMoneyIcon style={{
                                                paddingRight: '10px'
                                            }} />
                                            <span style={{ fontWeight: '600' }} > {profile.profile.hide_rate === true ? "0.0" : formatRate()} </span>
                                            </Button>
                                        }
                                        {isFailedShipment &&
                                        <LoadingButton
                                            variant="outlined"
                                            onClick={e => handleSubmit(e, "FAILEDGENERATE")}
                                            disabled={((rates && rates.loading) || createButtonDisable == true || orderId == "# " + currentOrderId) ? true: false}
                                            style={{ marginRight: '15px'}}
                                            loading={
                                                orders && orders.loading}
                                        >
                                            <AddCircleOutlineOutlinedIcon style={{
                                                paddingRight: '10px'
                                            }} /> Create
                                        </LoadingButton>
                                        }
                                        <LoadingButton
                                            variant="outlined"
                                            onClick={e => handleSubmit(e, "GENERATE")}
                                            disabled={((rates && rates.loading) || createButtonDisable == true || orderId == "# " + currentOrderId) ? true: false}
                                            loading={
                                                orders && orders.loading}
                                        >
                                            <AddCircleOutlineOutlinedIcon style={{
                                                paddingRight: '10px'
                                            }} /> Create + Print
                                    </LoadingButton>
                                    </>
                                }
                            </div>
                        </div>
                        <RateDrawer
                            visible={rateDrawervisible}
                            onClose={rateDraweronClose}
                            reportName={reportName}
                            meta={meta}
                            formDataValues={formDataValues}
                            newOrderFormData={newOrderFormData}
                            isDuplicateOrder={isDuplicateOrder}
                            lineItemId={lineItemId}
                            customLineItems={customLineItems}
                            setValues={setValues}
                            setNewOrderFormData={setNewOrderFormData}
                            setCustomLineItems={setCustomLineItems}
                            setRateDrawervisible={setRateDrawervisible}
                            setNewOrderCreateDrawerVisible={setNewOrderCreateDrawerVisible}
                            isReturnOrder={isReturnOrder}
                            isFailedShipment={isFailedShipment}
                            isShipmentCreationFlow={isShipmentCreationFlow}
                        />
                    </div>

                </div>
            </Drawer >
        </>
    )
}


export default NewOrderCreateDrawer;